import { useSelector } from 'react-redux';

import { makeGetTaskGroup } from 'selectors/task-groups';

const getTaskGroup = makeGetTaskGroup();

export const useTaskGroup = taskGroupId => {
    const taskGroup = useSelector(({ taskGroups }) => getTaskGroup(taskGroups.items, taskGroupId));

    return taskGroup;
};
